export enum BannerType {
  Messages = 1,
  Confirmation = 2
}
